import { css } from 'emotion';

import getButtonStyles from '../../../../../lib/styles/getButtonStyles';

import { TPADeviceType } from '@wix/podcasts-common/dist/tpa';
import {
  ButtonStyle,
  ISettingsColors,
} from '@wix/podcasts-common/dist/settings';

interface IGetStylesArgs {
  buttonStyle: ButtonStyle;
  deviceType: TPADeviceType;
  colors: ISettingsColors;
}

function getStyles({ buttonStyle, deviceType, colors }: IGetStylesArgs) {
  return {
    loadMoreButton: css({
      ...getButtonStyles({
        buttonStyle,
        buttonColor: colors.main.episodeButtonColor,
        buttonTextColor: colors.main.episodeButtonTextColor,
        emptyButtonHoverTextColor: colors.main.episodeListBackgroundColor,
      }),
      ...{
        [TPADeviceType.MOBILE]: {
          fontSize: 13,
        },
      }[deviceType],
    }),
  };
}

export default getStyles;
